import { useState } from "react";
import "./Nav.css";
import { useLenis } from "lenis/react";

function Nav() {
  const [navbarColor, setNavbarColor] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const lenis = useLenis();

  const [hashNavList] = useState([
    { to: "about", name: "About" },
    { url: "https://hashnode.com/@marswalker", name: "Blog" },
    { to: "skills", name: "Skills" },
    { to: "portfolio", name: "Portfolio" },
    { to: "experience", name: "Experience" },
    { to: "contactme", name: "Contact" },
  ]);

  const changeNavbar = () => {
    if (window.scrollY >= 500) {
      setNavbarColor(true);
    } else {
      setNavbarColor(false);
    }
  };

  window.addEventListener("scroll", changeNavbar);

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section && lenis) {
      lenis.scrollTo(section, {
        offset: -70,
        duration: 1.2,
        easing: (t) => 1 - Math.pow(1 - t, 3),
      });
    }
  };

  const handleNavClick = (data) => {
    setMenuOpen(false);
    if (data.to) {
      scrollToSection(data.to);
    } else if (data.url) {
      window.open(data.url, "_blank", "noopener,noreferrer");
    }
  };

  const handleLogoClick = () => {
    setMenuOpen(false);
    scrollToSection("home");
  };

  return (
    <>
      <nav
        className={
          "navbar-main fixed-top " +
          (navbarColor ? "navbar-color-dark" : "navbar-color-transparent") +
          (menuOpen ? " menu-is-open" : "")
        }
      >
        <div className="nav-cont">
          <div className="logoContainer">
            <span className="navbar-brand nav-logo" onClick={handleLogoClick}>
              <img className="logo img-fluid" src={"https://res.cloudinary.com/duti0qrg2/image/upload/v1771768798/IMG_1731_teluaz.jpg"} alt="logo" />
            </span>
          </div>

          {/* Desktop nav */}
          <ul className="desktop-nav">
            {hashNavList.map((data, index) => (
              <li key={index}>
                {data.to ? (
                  <span className="desktop-nav-link" onClick={() => scrollToSection(data.to)}>
                    {data.name}
                  </span>
                ) : (
                  <a
                    className="desktop-nav-link"
                    href={data.url}
                    rel="noreferrer"
                    target="_blank"
                  >
                    {data.name}
                  </a>
                )}
              </li>
            ))}
          </ul>

          {/* Hamburger button (mobile only) */}
          <button
            className={"hamburger" + (menuOpen ? " is-active" : "")}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>
        </div>
      </nav>

      {/* Full-screen mobile overlay */}
      <div className={"mobile-overlay" + (menuOpen ? " is-open" : "")}>
        <ul className="mobile-nav-list">
          {hashNavList.map((data, index) => (
            <li
              key={index}
              className="mobile-nav-item"
              style={{ animationDelay: `${0.08 * (index + 1)}s` }}
            >
              <span
                className="mobile-nav-link"
                onClick={() => handleNavClick(data)}
              >
                {data.name}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}

export default Nav;
